"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var SMBAccountModalState_1 = require("./SMBAccountModalState");
/** Platform Ui Components */
/** CMS */
var cms_integration_1 = require("@idp/cms-integration");
// import { SMBAccountModalCms } from './SMBAccountModal.cms';
/** Stylesheets */
var utilityStyles = require("../../../../styles/utilities.scss");
var styles = require("./SMBAccountModal.scss");
/** LOB Components */
var ModalGroup_1 = require("../../../common/ModalGroup");
var ModalGroupProps_1 = require("../../../common/ModalGroup/ModalGroupProps");
/** Api, Mappers, Request, Response, Reporting */
var ReportingService_1 = require("../../../../api/ReportingService");
var SMBAccountModal = /** @class */ (function (_super) {
    __extends(SMBAccountModal, _super);
    // private SMBAccountModalCmsData: SMBAccountModalCms;
    function SMBAccountModal(props) {
        var _this = _super.call(this, props) || this;
        _this.state = new SMBAccountModalState_1.default();
        _this.reportingService = new ReportingService_1.default();
        _this.closeXBtnEvents = _this.closeXBtnEvents.bind(_this);
        _this.closeBtnEvents = _this.closeBtnEvents.bind(_this);
        return _this;
    }
    SMBAccountModal.prototype.closeXBtnEvents = function () {
        this.modalClose();
    };
    SMBAccountModal.prototype.closeBtnEvents = function () {
        this.modalClose();
    };
    SMBAccountModal.prototype.modalClose = function () {
        this.reportingService.fireLinkClickEvent('Close', ReportingService_1.PageUrls.PASSCODE_PAGE);
        this.props.events.modalClosed();
    };
    SMBAccountModal.prototype.analyticsSMBAccountModalFormPageLoad = function () {
        this.reportingService
            .firePageLoadEvent(ReportingService_1.PageUrls.SMB_ACCOUNT_MODAL, ReportingService_1.PageName.SMB_ACCOUNT_MODAL);
    };
    SMBAccountModal.prototype.render = function () {
        var loginSmbAccountModalTestId = 'SMB_Account';
        // this.SMBAccountModalCmsData = CMS.get(new SMBAccountModalCms(), 'SMBAccountModal').content;
        this.SMBAccountModalCmsData = cms_integration_1.CMS.get({}, 'login').content.loginConsole;
        this.analyticsSMBAccountModalFormPageLoad();
        return (React.createElement("div", null,
            React.createElement(ModalGroup_1.default, { data: {
                    modalTitle: this.SMBAccountModalCmsData.passCode.smbModalTitle,
                    primaryBtnText: this.SMBAccountModalCmsData.passCode.smbModalCloseCTA,
                }, options: {
                    size: ModalGroupProps_1.ModalGroupSize.MEDIUM,
                    sizing: ModalGroupProps_1.ModalGroupSizing.NORMAL,
                    className: styles.loginSmbAccountModalWrapper,
                }, xIconBtnEvents: {
                    onClick: this.closeXBtnEvents,
                }, primaryBtnEvents: {
                    onClick: this.closeBtnEvents,
                }, testId: loginSmbAccountModalTestId },
                React.createElement("div", { className: [
                        utilityStyles.marTXs,
                        utilityStyles.padTXxxs,
                    ].join(' ') },
                    !this.props.data.wirelineModal &&
                        React.createElement("div", { className: [styles.visiblePhoneHiddenAll].join(' '), dangerouslySetInnerHTML: {
                                __html: this.SMBAccountModalCmsData.passCode.smbModalDescMobile,
                            } }),
                    !this.props.data.wirelineModal &&
                        React.createElement("div", { className: [styles.hiddenPhoneVisibleAll].join(' '), dangerouslySetInnerHTML: {
                                __html: this.SMBAccountModalCmsData.passCode.smbModalDescDesktop,
                            } }),
                    this.props.data.wirelineModal &&
                        React.createElement("div", { className: [styles.visiblePhoneHiddenAll].join(' '), dangerouslySetInnerHTML: {
                                __html: 'Call us at 888.944.0447 to reset your passcode.',
                            } }),
                    this.props.data.wirelineModal &&
                        React.createElement("div", { className: [styles.hiddenPhoneVisibleAll].join(' '), dangerouslySetInnerHTML: {
                                __html: 'Call us at 888.944.0447 to reset your passcode.',
                            } })))));
    };
    return SMBAccountModal;
}(React.Component));
exports.default = SMBAccountModal;
//# sourceMappingURL=SMBAccountModal.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/components/panels/Passcode/SMBAccountModal/SMBAccountModal.js
// module id = 657
// module chunks = 8